import React from "react";
import { separate } from "../../../../Utils/SeprateNumber/SeprateThreeNumber";
import Style from "./WalletInfo.module.scss";
import TransactionStatus from "./TransactionStatus/TransactionStatus";
const WalletInfo = ({ data }) => {
  return (
    <div className={Style.center}>
      {data.length === 0 ? (
        <h3 className={Style.textPoint}>تراکنشی موجود نیست!</h3>
      ) : (
        data &&
        data.map((item, index) => {
          return (
            <div
              key={index}
              className={item.amount < 0 ? Style.eachItemOut : Style.eachItemIn}
            >
              <h2 className={Style.textStyle}>
                {" "}
                شماره تراکنش:{" "}
                <span className={Style.details}>{separate(item.id)} </span>
              </h2>
              {item.amount > 0 ? (
                <h2 className={Style.textStyle}>
                  {" "}
                  شماره سفارش:{" "}
                  <span className={Style.details}>
                    {separate(item.order_id)}{" "}
                  </span>
                </h2>
              ) : null}
              {item.amount < 0 ? (
                <h2 className={Style.textStyle}>
                  {" "}
                  کارمزد:{" "}
                  <span className={Style.details}>{separate(item.wage)} </span>
                </h2>
              ) : null}
              <h2 className={Style.textStyle}>
                مقدار:{" "}
                <span className={Style.details}>{separate(item.amount)} </span>
                تومان
              </h2>
              <h2 className={Style.textStyle}>
                تاریخ :{" "}
                <span className={Style.details}>{separate(item.date)} </span>
              </h2>
              {item.amount < 0 ? <TransactionStatus id={item.id} /> : null}
            </div>
          );
        })
      )}
    </div>
  );
};

export default WalletInfo;
